import { useLocation } from 'react-router-dom'
import './App.css'
import { Routes } from './Routes/Routes'

function App () {
  return (
    <>
      <Routes />
    </>
  )
}

export default App
